import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyService } from '@rd/core/services/currency/currency.service';

@Pipe({
  name: 'localizeCurrency',
  pure: false,
  standalone: false,
})
export class LocalizeCurrencyPipe implements PipeTransform {
  constructor(private currencyService: CurrencyService) {}

  public transform(
    value: number,
    display: string,
    digitsInfo?: string,
  ): string {
    return this.currencyService.formatCurrency(value, display, digitsInfo);
  }
}
